import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import Select from '../../../_common/Form/Selects/Select/Select';
import classes from '../../PossiblePersons/Analytics/analytics.module.scss';
import AnalyticsChartWrapper from '../../PossiblePersons/Analytics/ChartComtonents/AnalyticsChartWrapper';
import { useQuery } from '../../../../utils/hooks/useQuery';
import api from '../../../../api/api';
import Loader from '../../../_common/Loader/Loader';

const chartTemplate = {
  series: [],
  chart: {
    type: 'bar',
    height: 350,
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      borderRadiusApplication: 'around',
      borderRadiusWhenStacked: 'all',
      borderRadius: 5,
      horizontal: true,
    },
  },
  legend: {
    show: false,
  },
  grid: {
    show: false,
  },
  tooltip: {
    // enabled: false,
    custom({
      series, seriesIndex, dataPointIndex, w,
    }) {
      if (seriesIndex) {
        return '';
      }

      return '<div class="arrow_box">'
        + `<span>${series[seriesIndex][dataPointIndex]}</span>`
        + '</div>';
    },
  },
  dataLabels: {
    show: true,
    enabled: true,
    formatter(val, d) {
      if (d.seriesIndex === 0) {
        return `${val}%`;
      }
      return '';
    },
    // offsetX: 200,
    // offsetY: 0,
    // style: {
    //   fontSize: '12px',
    //   colors: ['#304758'],
    //   position: 'absolute',
    //   right: 0,
    // },
  },
  xaxis: {
    max: 100,
    show: true,
    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
    labels: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      style: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        colors: '#615E83',
      },
    },
  },
  colors: ['#4A3AFF', '#F8F8FF'],
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');

function MessageVolume(props) {
  const { query, setQuery } = useQuery();

  const {
    volId, volName, volStart, volEnd,
  } = query;

  const [chart, setChart] = useState(chartTemplate);
  const [loading, setLoading] = useState(false);

  const [healthValue, setHealthValue] = useState(volName || '');

  const [requestData, setRequestData] = useState({
    start: volStart || thisMonthStartDay,
    end: !volStart ? thisMonthEndDate : (volEnd || ''),
    healthPlanId: volId || '',
    healthPlanName: volName || '',
  });

  const {
    start, end, healthPlanId, healthPlanName,
  } = requestData;

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data } = await api.getMessageVolume({
        startDate: start,
        endDate: end || moment(start).add(1, 'day').format('YYYY-MM-DD'),
        healthPlanId,
      });

      setQuery({
        ...query, volStart: start, volEnd: end, volId: healthPlanId, volName: healthPlanName,
      });

      const dataArray = data.data.map((d) => d.qty);
      const sum = _.sum(dataArray);

      setChart((prev) => ({
        ...prev,
        series: [{
          name: 'Messages',
          data: data.data.map((d) => (d.qty ? (+d.qty * 100) / sum : 0).toFixed(1)),
        }, {
          name: '',
          data: data.data.map((d) => 100 - (d.qty ? (+d.qty * 100) / sum : 0)),
        }],
        yaxis: {
          ...prev.yaxis,
        },
        xaxis: {
          ...prev.xaxis,
          categories: data.data[0].rangeType === 'week'
            ? data.data.map((d) => `${moment(d.startDate).format('MMM DD')} - ${moment(d.endDate).format('MMM DD')}`)
            : data.data[0].rangeType === 'month' ? data.data.map((d) => moment(d.time).format('MMM'))
              : data.data.map((d) => moment(d.time).format('MMM DD')),
        },
      }));

      setLoading(false);
    })();
  }, [requestData]);

  const changeDateAndHealth = (value, path, planName) => {
    setRequestData((prev) => {
      if (path === 'date') {
        return {
          ...prev,
          start: value[0],
          end: value[1],
        };
      }

      return {
        ...prev,
        [path]: value,
        healthPlanName: planName,
      };
    });
  };

  return (
    <AnalyticsChartWrapper
      title="Message volume"
      date={requestData}
      healthValue={healthValue}
      setHealthValue={setHealthValue}
      onChange={changeDateAndHealth}
      className={classes.bottom_chart_analytics}
    >
      {loading
        ? <div className={classes.loader_wrapper}><Loader /></div>

        : +_.max(chart?.series?.[0]?.data) === 0 && !loading
          ? <div className={classes.notResult}>No Data Found</div>

          : (
            <Chart
              options={chart}
              series={chart.series}
              height={300}
              type="bar"
              width="100%"
            />
          )}
    </AnalyticsChartWrapper>
  );
}

export default MessageVolume;
